import { render, staticRenderFns } from "./HomePageServiceFeatures.vue?vue&type=template&id=f040a6ac&scoped=true"
import script from "./HomePageServiceFeatures.vue?vue&type=script&lang=js"
export * from "./HomePageServiceFeatures.vue?vue&type=script&lang=js"
import style0 from "./HomePageServiceFeatures.vue?vue&type=style&index=0&id=f040a6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f040a6ac",
  null
  
)

export default component.exports